import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["playlists"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { setAlert } from 'actions/alerts';
function useUpdatePlaylistsAudiences(_ref) {
  var playlists = _ref.playlists,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  function updateAudiences(_x) {
    return _updateAudiences.apply(this, arguments);
  }
  function _updateAudiences() {
    _updateAudiences = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var audience, _ref2$teamIdsToAdd, teamIdsToAdd, _ref2$teamIdsToRemove, teamIdsToRemove, promises, playlistIds, playlistsWithChangedAudienceIds, contentTeams, _yield$api, contentTeamsToDelete, contentTeamsIds;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            audience = _ref2.audience, _ref2$teamIdsToAdd = _ref2.teamIdsToAdd, teamIdsToAdd = _ref2$teamIdsToAdd === void 0 ? [] : _ref2$teamIdsToAdd, _ref2$teamIdsToRemove = _ref2.teamIdsToRemove, teamIdsToRemove = _ref2$teamIdsToRemove === void 0 ? [] : _ref2$teamIdsToRemove;
            promises = [];
            playlistIds = playlists.map(function (playlist) {
              return playlist.id;
            });
            if (audience) {
              playlistsWithChangedAudienceIds = playlists.filter(function (playlist) {
                return playlist.audience !== audience;
              }).map(function (playlist) {
                return playlist.id;
              });
              if (playlistsWithChangedAudienceIds.length > 0) {
                promises.push(api('patch', '/api/query/playlist/', {
                  filter: {
                    id: playlistsWithChangedAudienceIds
                  }
                }, {
                  audience: audience
                }));
              }
            }
            if (teamIdsToAdd.length > 0) {
              contentTeams = [];
              playlistIds.forEach(function (playlistId) {
                contentTeams.push.apply(contentTeams, _toConsumableArray(teamIdsToAdd.map(function (teamId) {
                  return {
                    content_id: playlistId,
                    team_id: teamId
                  };
                })));
              });
              promises.push(api('post', '/api/query/contentTeams', null, contentTeams));
            }
            if (!(teamIdsToRemove.length > 0)) {
              _context.next = 12;
              break;
            }
            _context.next = 8;
            return api('get', '/api/query/contentTeams', {
              fields: ['id'],
              filter: {
                team_id: teamIdsToRemove,
                assetDomains: {
                  asset_id: playlistIds
                }
              }
            });
          case 8:
            _yield$api = _context.sent;
            contentTeamsToDelete = _yield$api.items;
            contentTeamsIds = contentTeamsToDelete.map(function (_ref3) {
              var id = _ref3.id;
              return id;
            });
            promises.push(api('delete', '/api/query/contentTeams', {
              filter: {
                id: contentTeamsIds
              }
            }));
          case 12:
            return _context.abrupt("return", Promise.all(promises));
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _updateAudiences.apply(this, arguments);
  }
  var _useMutation = useMutation(updateAudiences, _objectSpread(_objectSpread({}, options), {}, {
      onError: function onError() {
        setAlert({
          key: 'playlist-access-error',
          title: t('alert_playlist_audience_error', {
            count: playlists.length
          })
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    updatePlaylistsAudiences: mutateAsync
  });
}
export default useUpdatePlaylistsAudiences;